import { useQuery } from '@tanstack/react-query';
import api from '../lib/api.js';
import { useScopeKey } from './useScopeKey.js';

export function useStatsMonthly(year) {
  const scopeKey = useScopeKey();
  return useQuery({
    queryKey: ['stats', 'monthly', scopeKey, year],
    queryFn: () => api.get(`/stats/monthly?year=${year}`),
    staleTime: 60_000,
    enabled: !!year && scopeKey !== 'loading',
    // L'API renvoie { year, months: [...] }. On aplatit en array de
    // mois avec `year` injecté sur chaque row — les composants peuvent
    // directement iterer `.reduce()`, `.map()`, `.find()` dessus.
    select: (d) =>
      Array.isArray(d) ? d : (d?.months ?? []).map((m) => ({ ...m, year: d?.year ?? m.year })),
  });
}
